module.exports = __webpack_public_path__ + "img/destination_point.d8388350.svg";